import { StringKey } from '../lang/index';

export enum SubscriptionDuration {
  ANNUALY = 'annualy',
  MONTHLY = 'monthly',
}

export const subscriptionDurationMap: Record<SubscriptionDuration, StringKey> = {
  [SubscriptionDuration.ANNUALY]: 'ANNUALY',
  [SubscriptionDuration.MONTHLY]: 'MONTHLY',
};

export enum SubscriptionType {
  ENTERPRISE = 'enterprise',
  GROWTH = 'growth',
  START_UP = 'startup',
}

export const SubscriptionTypeTitle: Record<SubscriptionType, StringKey> = {
  [SubscriptionType.START_UP]: 'STARTUP',
  [SubscriptionType.GROWTH]: 'GROWTH',
  [SubscriptionType.ENTERPRISE]: 'ENTERPRISE',
};

export type Plan = {
  duration: SubscriptionDuration;
  id: string;
  localCurrency: string;
  localPrice: number;
  priceInCents: number;
  stakeholdersCount: number;
  stripePriceId: string;
  title: string;
  type: SubscriptionType;
};
